<template>
    <section class="order-status-content">
        <div class="container">
            <div class="row">
                <div class="col-sm-4">
                    <h1>{{ orderStatus }}</h1>
                    <p class="order-number">Order No. {{ order.orderID }}</p>

                    <order-status-description :order="order" :product="product" />
                </div>
                <div class="col-sm-4 offset-sm-4">
                    <order-status-graphic :order="order" :product="product" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import OrderStatusDescription from "./order-status-description";
import OrderStatusGraphic from "./order-status-graphic";
import {inject} from "@vue/compat";

export default {
    name: "order-status-content",
    components: {OrderStatusGraphic, OrderStatusDescription},
    props: [
        'order',
        'product'
    ],
    computed: {
        orderStatus() {
            const $origoStatus = inject('origoStatus');
            return (this.order && this.product?.name ? $origoStatus(this.order.orderStatusDescription, this.product) : 'Order');
        }
    }
}
</script>

<style scoped>
.order-status-content{
    background: #fff;
    padding:4rem 0;
}
</style>
